import _ from 'lodash';
import React from 'react';
var Paginator = function Paginator(_ref) {
  var invoices = _ref.invoices,
    pages = _ref.pages,
    pagination = _ref.pagination,
    onChangePage = _ref.onChangePage;
  if (invoices.length < 10 || pages.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pagination-wrapper"
  }, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
    className: "pagination"
  }, /*#__PURE__*/React.createElement("li", {
    className: "".concat(pagination.previous ? 'page-item' : 'page-item disabled')
  }, pagination.previous ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "skip-tracking page-link",
    onClick: function onClick() {
      return onChangePage(pagination.previous);
    }
  }, "\xAB") : /*#__PURE__*/React.createElement("span", {
    className: "page-link"
  }, "\xAB")), _.map(pages, function (page) {
    return /*#__PURE__*/React.createElement("li", {
      key: page,
      className: "".concat(page !== pagination.current ? 'page-item' : 'page-item disabled active')
    }, page !== pagination.current ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "skip-tracking page-link",
      onClick: function onClick() {
        return onChangePage(page);
      }
    }, page + 1) : /*#__PURE__*/React.createElement("span", {
      className: "page-link current-page"
    }, page + 1));
  }), /*#__PURE__*/React.createElement("li", {
    className: "".concat(pagination.next && pages.indexOf(pagination.next) !== -1 ? 'page-item' : 'page-item disabled')
  }, pagination.next && pages.indexOf(pagination.next) !== -1 ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "skip-tracking page-link",
    onClick: function onClick() {
      return onChangePage(pagination.next);
    }
  }, "\xBB") : /*#__PURE__*/React.createElement("span", {
    className: "page-link"
  }, "\xBB")))));
};
export default Paginator;